/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'pin': {
    width: 18,
    height: 24,
    viewBox: '0 0 18 24',
    data: '<path pid="0" d="M7.727 22.55C1.168 13.118 0 12.13 0 8.626A8.599 8.599 0 018.625 0a8.627 8.627 0 018.625 8.625c0 3.504-1.213 4.492-7.771 13.926a1.05 1.05 0 01-1.752 0zm.898-10.331a3.576 3.576 0 003.594-3.594 3.604 3.604 0 00-3.594-3.594 3.576 3.576 0 00-3.594 3.594c0 2.021 1.573 3.594 3.594 3.594z" _fill="#3E4749"/>'
  }
})
